import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";

interface ICheckboxProps {
    checked: boolean;
    id?: string;
    dataCy?: string;
    operation?: number;
    target?: CheckboxTarget;
    label?: string;
    maxLen?: number;
    style?: React.CSSProperties;
    labelStyle?: any;
    item?: any;
    extraItem?: any;
    className?: string;
    DivWrap?: boolean
    idModifier?: string;
    disabled?: boolean;
    onChange?: (isChecked: boolean, id: string, target?: number) => void;
    wrapSpan?: boolean;
    title?: string;
    labelClassName?: string;
    justifyContent?: "flex-start" | "flex-end" | "center" | "space-between" | "space-around" | "space-evenly" | "stretch";
    fixTextSelectionInterference?: boolean;
    truncateText?: boolean;

    operationArg1?: any;
    operationArg2?: any;
    operationArg3?: any;
}

class CheckboxControl extends React.Component<ICheckboxProps, never> {
    private textSelectionRange: Range | null = null;

    public render(): JSX.Element {
        const maxLen = this.props.maxLen;
        const text = maxLen > 0
            ? MyleHelper.ShortenString(this.props.label, maxLen)
            : this.props.label;

        const labelStyle = this.props.labelStyle;

        const classname = this.props.className;

        let checkbox = (
            <input
                disabled={this.props.disabled}
                className={classname}
                style={this.props.style}
                type="checkbox"
                id={this.props.id}
                data-cy={this.props.dataCy}
                onChange={e => {
                    this.onCheckChange(e);

                    if (!this.props.fixTextSelectionInterference || !this.textSelectionRange)
                        return;

                    const selection = window.getSelection();
                    selection?.removeAllRanges();
                    selection?.addRange(this.textSelectionRange); // restore the text selection
                    this.textSelectionRange = null;
                }}
                checked={this.props.checked}
            />
        );

        let spanStyle: React.CSSProperties = {};
        if (this.props.wrapSpan)
            spanStyle.whiteSpace = "pre-wrap";

        if (this.props.label?.length > 0) {
            checkbox = (
                <label
                    htmlFor={this.props.id}
                    title={this.props.title || this.props.label}
                    style={labelStyle}
                    className={this.props.labelClassName}
                    onClick={() => {
                        if (!this.props.fixTextSelectionInterference || this.props.disabled)
                            return;

                        const selection = window.getSelection();

                        if (!selection || selection.rangeCount === 0)
                            return;

                        this.textSelectionRange = selection.getRangeAt(0);
                        selection.removeAllRanges(); // the current text selection somehow intermittently interferes with the label click
                    }}
                >
                    <div className="flex-container" style={{ "justifyContent": this.props.justifyContent ?? "flex-start", alignItems: "center" }}>
                        <div className="editablecell">{checkbox}</div>
                        <div className={`editablecell ${this.props.truncateText ? "ellipsis-auto" : ""}`} style={{ marginLeft: "5px" }}><span style={spanStyle}>{text}</span></div>
                    </div>
                </label>
            );
        }

        if (this.props.DivWrap)
            checkbox = <div>{checkbox}</div>;

        return checkbox;
    }

    public onCheckChange(e: React.ChangeEvent<HTMLInputElement>): void {
        const idToSend = this.props.idModifier
            ? this.props.id.replace(this.props.idModifier, "")
            : this.props.id;

        if (this.props.operation) {
            sessionStore.dispatch(
                this.props.operation,
                {
                    item: this.props.item,
                    extraItem: this.props.extraItem,
                    target: this.props.target, // allows matching messages when several checkboxes with different-but-similar behaviors use the same operation
                    checked: e.target.checked,
                    arg1: this.props.operationArg1,
                    arg2: this.props.operationArg2,
                    arg3: this.props.operationArg3,
                    id: idToSend
                }
            );
        }
        this.props.onChange?.(e.target.checked, idToSend, this.props.target);
    }
}

export { CheckboxControl, ICheckboxProps };
